"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingApprovalAuditTransport = exports.PricingChange = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PricingChange = typebox_1.Type.Object({
    size: typebox_1.Type.String(),
    oldHaul: typebox_1.Type.Optional(typebox_1.Type.Number()),
    haul: typebox_1.Type.Optional(typebox_1.Type.Number()),
    oldDump: typebox_1.Type.Optional(typebox_1.Type.Number()),
    dump: typebox_1.Type.Optional(typebox_1.Type.Number()),
    oldOver: typebox_1.Type.Optional(typebox_1.Type.Number()),
    over: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.PricingApprovalAuditTransport = typebox_1.Type.Object({
    zoneID: typebox_1.Type.String(),
    zoneName: typebox_1.Type.String(),
    materialID: typebox_1.Type.Optional(typebox_1.Type.String()),
    material: typebox_1.Type.Optional(typebox_1.Type.String()),
    pricingChanges: typebox_1.Type.Optional(typebox_1.Type.Array(exports.PricingChange)),
    feeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.String(),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('ZONE'), typebox_1.Type.Literal('MATERIAL'), typebox_1.Type.Literal('FEE'), typebox_1.Type.Literal('SERVICE_AREA')]),
});
//# sourceMappingURL=pricing-approval-audit.js.map